import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap-5';

import { get } from 'helpers/api';

export default function ImportProgress({ fileName, importJobId, objectName, onComplete }) {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const checkProgress = () => {
      get(`/import_jobs/${importJobId}`).then(({ complete, progress: progressValue, summary }) => {
        if (complete) {
          // Show 100% progress before transitioning
          setProgress(100);
          timeoutRef.current = setTimeout(() => {
            onComplete(summary);
          }, 800);
        } else {
          setProgress(progressValue || 0);
        }
      });
    };

    // Start polling immediately and then every 2 seconds
    intervalRef.current = setInterval(checkProgress, 2000);

    // Cleanup function
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [importJobId, onComplete]);

  return (
    <>
      <p className="fs-large mt-7 mb-2 text-uppercase text-muted">
        <strong className="fw-semibold">{fileName}</strong>
      </p>
      <div
        className={
          'd-flex flex-column align-items-center justify-content-center ' +
          'py-5 px-2 mb-2 ds-border ds-border-dashed'
        }
      >
        <ProgressBar animated className="mb-4 w-100" now={progress} />
        <p className="fs-large m-0">
          {progress > 0 ? `${Math.round(progress)}% of ${objectName} Imported` : `Importing ${objectName}...`}
        </p>
      </div>
    </>
  );
}

ImportProgress.propTypes = {
  fileName: PropTypes.string.isRequired,
  importJobId: PropTypes.number.isRequired,
  objectName: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired
};
